import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { renderExtension } from './extension';
import ExtensionRenderer from '../../ui/ExtensionRenderer';
const BodiedExtension = props => {
  const {
    children,
    layout = 'default',
    path = []
  } = props;
  const removeOverflow = React.Children.toArray(children).map(child => /*#__PURE__*/React.isValidElement(child) ? child.props.nodeType === 'table' : false).every(Boolean);
  return /*#__PURE__*/React.createElement(ExtensionRenderer, _extends({}, props, {
    type: "bodiedExtension"
  }), ({
    result
  }) => {
    try {
      if (result && /*#__PURE__*/React.isValidElement(result)) {
        // Return the content directly if it's a valid JSX.Element
        return renderExtension(result, layout, {
          isTopLevel: path.length < 1
        }, removeOverflow);
      }
    } catch (e) {
      /** We don't want this error to block renderer */
      /** We keep rendering the default content */
    }

    // Always return default content if anything goes wrong
    return renderExtension(children, layout, {
      isTopLevel: path.length < 1
    }, removeOverflow);
  });
};
export default BodiedExtension;